// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"47fb596b","39":"47fb596b","320":"e3cba315","353":"dc907b7f","403":"3045a7a2","468":"47fb596b","475":"4c92b5ba","741":"f9339d72"}[chunkId] + ".chunk.css";
};